import {
  MedRecSwitch,
  Promotion,
  SearchHeader,
  StoreLocator,
} from '@/components';

import {
  HeaderBurgerNav,
  HeaderFavorites,
  HeaderLogo,
  HeaderProfile,
  HeaderRow,
  HeaderSection,
  HeaderShopping,
} from '../../Header.components';

const HeaderWithCenteredLogoAndLocatorFixMobile = () => (
  <>
    <HeaderRow borderless differentBackground type="small">
      <HeaderSection justify="center" spaceBetweenOnMultipleChildren>
        <StoreLocator />
        <MedRecSwitch compact />
      </HeaderSection>
    </HeaderRow>
    <HeaderRow borderless fullWidth type="flat">
      <Promotion location="header" />
    </HeaderRow>
    <HeaderRow type="small">
      <HeaderSection justify="start">
        <HeaderBurgerNav />
        <HeaderLogo fullWidth />
      </HeaderSection>
      <HeaderSection justify="end">
        <SearchHeader withEmbeddedInput />
        <HeaderProfile />
        <HeaderFavorites />
        <HeaderShopping />
      </HeaderSection>
    </HeaderRow>
  </>
);

export { HeaderWithCenteredLogoAndLocatorFixMobile };
